module.exports = __webpack_public_path__ + "media/reskin-images/icon--smartphone-active-a4078fa4.svg";